module.exports = __webpack_public_path__ + "img/北京大学.afddbf62.png";